import Component from '@glimmer/component';
import { action } from '@ember/object';
import { guidFor } from '@ember/object/internals';
import { scheduleOnce } from '@ember/runloop';
import { cached, tracked } from '@glimmer/tracking';

export interface IPanel {
  panelId: string;
  backPanelId?: string;
}

export interface IBvStackNavApi {
  panels: IPanel[];
  current?: IPanel;
  actions: {
    goto: (panelId: string) => void;
    back: () => void;
    register: (panel: IPanel) => void;
  };
  id: string;
  ready: boolean;
}

interface IArgs {
  currentPanelId: string;
  onChange?: (panel: IPanel) => void;
}

export default class BvStackNav extends Component<IArgs> {
  id = guidFor(this);
  @tracked panels: IPanel[] = [];
  @tracked currentPanelId: string = this.args.currentPanelId;
  @tracked ready: boolean = false;

  // CPs
  // ~~~~~~~~~

  @cached
  get panelIds() {
    return this.panels.map((p) => p.panelId);
  }

  @cached
  get current() {
    return this.panels.findBy('panelId', this.currentPanelId);
  }

  get backPanel() {
    const { panels, current } = this;

    if (current) {
      const backPanelId = current.backPanelId;
      if (backPanelId) {
        return panels.findBy('panelId', backPanelId);
      }
    }

    return undefined;
  }

  get publicAPI(): IBvStackNavApi {
    const { panels, current, goto, back, register, id, ready } = this;
    return {
      panels,
      current,
      actions: {
        goto,
        back,
        register
      },
      id,
      ready
    };
  }

  @action
  register(panel: IPanel) {
    if (!this.hasPanelId(panel.panelId)) {
      this.panels = this.panels.concat([panel]);
    }
  }

  @action
  goto(panelId: string) {
    if (!this.ready) {
      this.ready = true;
    }
    //run.scheduleOnce('actions', this, this.updateCurrent, panelId);
    this.updateCurrent(panelId);
  }

  @action
  back() {
    const { current } = this;

    if (current?.backPanelId) {
      //this.updateCurrent(current.backPanelId);
      scheduleOnce('actions', this, this.updateCurrent, current.backPanelId);
    }
  }

  updateCurrent(id?: string) {
    if (id && this.hasPanelId(id) && id !== this.currentPanelId) {
      this.currentPanelId = id;
      this.args.onChange?.(this.current!);
    }
  }

  private hasPanelId(id: string): boolean {
    return this.panelIds.includes(id);
  }
}
